import type { App, Plugin } from "vue";

import { VueDatePicker } from "@vuepic/vue-datepicker";

declare module "vue"
{
    export interface GlobalComponents
    {
        VueDatePicker: typeof VueDatePicker;
    }
}

const vueDatePicker: Plugin = { install: ({ component }: App) => component("VueDatePicker", VueDatePicker) };

export default vueDatePicker;
